// frontend/src/components/common/QuizVerificationSection.js
import React from 'react';
import { useLandingTranslation } from '../../hooks/useLandingTranslation';

const QuizVerificationSection = ({ className = "" }) => {
  const { t } = useLandingTranslation('profezac'); // Using profezac translations

  return (
    <div className={`${className}`}>
      {/* Feature Header */}
      <div className="text-center mb-5">
        <div className="mb-3">
          <span 
            className="badge px-3 py-2 fw-bold"
            style={{ 
              backgroundColor: '#17a2b8', 
              color: 'white', 
              fontSize: '0.9rem',
              borderRadius: '20px'
            }}
          >
            {t('quiz_verification.badge')}
          </span>
        </div>
        <h2 className="display-6 fw-bold mb-3" style={{ color: '#333' }}>
          {t('quiz_verification.title')}
        </h2>
        <p className="lead text-muted">
          {t('quiz_verification.subtitle')}
        </p>
      </div>
      <div className="mt-3">
        {/* Interactive Quizzes */}
        <div className="bg-primary bg-opacity-10 rounded-3 p-3 mb-3 text-center">
          <div className="border border-2 border-primary rounded mb-2 d-inline-block" style={{ margin: '0 auto' }}>
            <img 
              src="/images/quizimage.png" 
              alt="Interactive Quiz" 
              style={{ display: 'block', maxWidth: '200px', height: 'auto' }}
            />
          </div>
          <div className="text-primary fw-medium mb-2">
            <span className="fs-5 me-1">📝</span>
            <small>{t('quiz_verification.smart_quizzes_title')}</small>
          </div>
          <p className="text-muted small mb-0">
            {t('quiz_verification.smart_quizzes_description')}
          </p>
        </div>
        
        {/* Quiz Results */}
        <div className="bg-primary bg-opacity-10 rounded-3 p-3 mb-3 text-center">
          <div className="border border-2 border-primary rounded mb-2 d-inline-block" style={{ margin: '0 auto' }}>
            <img 
              src="/images/quizimage3.png" 
              alt="Quiz Results" 
              style={{ display: 'block', maxWidth: '220px', height: 'auto' }}
            />
          </div>
          <div className="text-primary fw-medium mb-2">
            <span className="fs-5 me-1">📊</span>
            <small>{t('quiz_verification.instant_feedback_title')}</small>
          </div>
          <p className="text-muted small mb-0">
            {t('quiz_verification.instant_feedback_description')}
          </p>
        </div>
        
        {/* Complete Subtitles */}
        <div className="bg-success bg-opacity-10 rounded-3 p-3 mb-2 text-center">
          <div className="border border-2 border-success rounded mb-2 d-flex align-items-center justify-content-center" style={{ height: '280px', width: '280px', margin: '0 auto', overflow: 'hidden' }}>
            <img 
              src="/images/transcript.png" 
              alt="Complete Subtitles" 
              style={{ height: '100%', width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
            />
          </div>
          <div className="text-success fw-medium mb-2">
            <span className="fs-5 me-1">📄</span>
            <small>{t('quiz_verification.reward_transcripts_title')}</small>
          </div>
          <p className="text-muted small mb-0">
            {t('quiz_verification.reward_transcripts_description')}
          </p>
        </div>
      </div>
      
      {/* Results Summary */}
      <div className="text-center mt-4">
        <div className="bg-info bg-opacity-10 rounded p-4">
          <h4 className="fw-bold text-info mb-3">{t('quiz_verification.result_title')}</h4>
          <p className="text-dark mb-3">
            {t('quiz_verification.result_description')}
          </p>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-center">
                <span className="text-success me-2" style={{ fontSize: '1.5rem' }}>✓</span>
                <span className="fw-medium">{t('quiz_verification.verified_understanding')}</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-center">
                <span className="text-success me-2" style={{ fontSize: '1.5rem' }}>✓</span>
                <span className="fw-medium">{t('quiz_verification.measurable_progress')}</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-center">
                <span className="text-success me-2" style={{ fontSize: '1.5rem' }}>✓</span>
                <span className="fw-medium">{t('quiz_verification.english_confidence')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizVerificationSection;